import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-inline-confirmation-operators',
  standalone: true,
  imports: [],
  templateUrl: './inline-confirmation-operators.component.html',
  styleUrl: './inline-confirmation-operators.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class InlineConfirmationOperatorsComponent {}
